import { createContext, useContext } from "react";

/**
 * What the shell knows about the sidebar, for the topbar and sidebar to share
 * without every page threading props through.
 *
 * Wide: icon rail is always on. Narrow: labelled drawer.
 */
export interface ShellState {
  /** The viewport is too narrow for a permanent sidebar column. */
  narrow: boolean;
  /**
   * Narrow: labelled drawer is open. Wide: unused (icon rail is always on).
   */
  sidebarOpen: boolean;
  toggleSidebar: () => void;
  openSidebar: () => void;
  closeSidebar: () => void;
}

export const ShellContext = createContext<ShellState>({
  narrow: false,
  sidebarOpen: false,
  toggleSidebar: () => {},
  openSidebar: () => {},
  closeSidebar: () => {},
});

export function useShell(): ShellState {
  return useContext(ShellContext);
}

/** Below this the sidebar becomes a drawer. Matches the CSS breakpoint. */
export const NARROW_QUERY = "(max-width: 900px)";

export const SIDEBAR_KEY = "sc_sidebar_v1";

/** Wide-screen leftover; the labeled panel is gone, so this stays closed. */
export function readSidebarPref(): boolean {
  return false;
}

export function writeSidebarPref(open: boolean): void {
  try {
    localStorage.setItem(SIDEBAR_KEY, open ? "open" : "closed");
  } catch {
    /* private mode: the choice lasts for this page only */
  }
}
